/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_TitleInputs */

const en_gc_resources_compare_title = /** @type {(inputs: Gc_Resources_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft vs Excel. Choose with context.`)
};

const zh_gc_resources_compare_title = /** @type {(inputs: Gc_Resources_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 与 Excel，按需选择。`)
};

/**
* | output |
* | --- |
* | "GridCraft vs Excel. Choose with context." |
*
* @param {Gc_Resources_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_title = /** @type {((inputs?: Gc_Resources_Compare_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_title(inputs)
	return zh_gc_resources_compare_title(inputs)
});
export { gc_resources_compare_title as "gc.resources.compare.title" }